export default [
    { key: "Sand", text: "Sand", value: "Sand" },
    { key: "Sandy loam", text: "Sandy loam", value: "Sandy loam" },
    { key: "Loam", text: "Loam", value: "Loam" },
    { key: "Clay loam", text: "Clay loam", value: "Clay loam" },
];